import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.CoreDialog, {
    attrs: {
      title: `${_setup.i18next.t("Выберите свой город в", {
        ns: _setup.userLanguage,
      })} ${_setup.namePred}`,
      "data-qa": "dialog-town-select",
      size: "xl",
    },
    scopedSlots: _vm._u([
      {
        key: "prependBtn",
        fn: function () {
          return [
            _c(
              VIcon,
              {
                staticClass: "cursor-pointer",
                attrs: { "data-qa": "dialog-town-select-close" },
                on: {
                  click: function ($event) {
                    _setup.isDialogActive = false
                  },
                },
              },
              [_vm._v("\n      ui-icon-close-not-a-circle\n    ")]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "default",
        fn: function () {
          return [
            _c(_setup.SearchCombobox, {
              staticClass: "pb-2",
              attrs: {
                "use-no-data-slot": "",
                "initial-data": _setup.searchData,
                placeholder: _setup.i18next.t(
                  "Начните вводить название, а мы подскажем",
                  { ns: _setup.userLanguage }
                ),
                "data-qa": "dialog-town-select-search",
              },
              on: {
                "search:default": _setup.handleSearchDefault,
                "search:text": _setup.handleSearchText,
                "search:class": _setup.handleSearchClass,
              },
              scopedSlots: _vm._u([
                {
                  key: "no-data",
                  fn: function () {
                    return [
                      _c(
                        VListItem,
                        [
                          _c(
                            VListItemContent,
                            [
                              _c(
                                VListItemTitle,
                                { staticClass: "text-secondary--text pa-2" },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_setup.helpText) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "py-3 mt-2" },
              [
                _c(_setup.TownList, {
                  attrs: {
                    towns: _setup.mainTowns,
                    "data-qa": "dialog-main-town-select-list",
                    "text-style": "text-subtitle-1",
                  },
                  on: { "click:redirect": _setup.redirectTown },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(_setup.TownList, {
              attrs: {
                towns: _setup.towns,
                "data-qa": "dialog-town-select-list",
                "text-style": "text-body-1",
              },
              on: { "click:redirect": _setup.redirectTown },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt-6" },
              [
                _c("div", { staticClass: "text-h6 pa-3" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_setup.otherCountriesTitle) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c(_setup.TownList, {
                  staticClass: "mt-4",
                  attrs: {
                    towns: _setup.otherCountries,
                    "text-style": "text-body-1",
                    "data-qa": "dialog-country-select-list",
                  },
                  on: { "click:redirect": _setup.redirectCountry },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
    model: {
      value: _setup.isDialogActive,
      callback: function ($$v) {
        _setup.isDialogActive = $$v
      },
      expression: "isDialogActive",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }